import React from 'react';
import './Preloader.less';
import ElipsisLoader from '../Loaders/ElipsisLoader';
import StatusScreen from '../StatusScreen/StatusScreen';

const Preloader = () => {
    return (
        <StatusScreen>
            <ElipsisLoader />
        </StatusScreen>
    )
}

export default Preloader
